import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import WidgetPlaceholderContainer from './WidgetPlaceholderContainer';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { BlockIcon } from 'foundations-assets/icons/components/BlockIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MissingSpecPlaceholder = () => /*#__PURE__*/_jsx(WidgetPlaceholderContainer, {
  children: /*#__PURE__*/_jsxs(TFlex, {
    flexDirection: "column",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: BlockIcon,
      size: "600"
    }), /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "layoutBuilder.placeholders.missingSpec"
      })
    })]
  })
});
export default MissingSpecPlaceholder;